import React, { useMemo, memo } from 'react'
import injectSheet from 'react-jss'
import styles, { wordStyles } from './slide.styles'
import Slide from '../../../components/slide/slide.jsx'
import { withPresentation } from '../../../presentation-connectors'
import Heading from '../../../components/heading/heading.jsx'
import ScrollFade from '../../../components/scroll-fade/scroll-fade.jsx'
import classNames from 'classnames'
import shuffle from 'lodash/shuffle'

const WordComponent = ({ text, color, classes, random }) => (
  <div
    className={classNames(classes.word, { [classes.random]: random })}
    style={{ backgroundColor: color }}>
    {text.trim()}
  </div>
)

const Word = withPresentation(injectSheet(wordStyles)(WordComponent))

const WordBankSlide = memo(({ classes, slides, id }) => {
  const data = slides[id]

  const slideData = useMemo(
    () => ({
      title: data.title,
      bank: data.bank,
      layout: data.layout
    }),
    [data]
  )

  const { emptyTitles, words, shuffledWords } = useMemo(() => {
    const emptyTitles = !slideData.bank.filter(group => !!group.title).length
    const words = slideData.bank.map(group =>
      group.words
        .split(',')
        .filter(word => !!word.trim())
        .map(word => ({
          text: word.trim(),
          color: group.color
        }))
    )

    const shuffledWords = shuffle(words.flat())

    return {
      emptyTitles,
      words,
      shuffledWords
    }
  }, [slideData.bank])

  return (
    <Slide className={classes.container}>
      <Heading className={classes.head}>{slideData.title}</Heading>
      {slideData.layout === 'column' && (
        <div className={classes.bank}>
          {!emptyTitles && (
            <div
              className={classes.titles}
              style={{
                gridTemplateColumns: `repeat(${slideData.bank.length}, 1fr)`
              }}>
              {slideData.bank.map((group, index) => (
                <p key={index} className={classes.groupTitle}>
                  {group.title}
                </p>
              ))}
            </div>
          )}
          <div
            className={classes.words}
            style={{
              gridTemplateColumns: `repeat(${slideData.bank.length}, 1fr)`
            }}>
            {words.map((wordsGroup, index) => (
              <div key={index} className={classes.group}>
                {wordsGroup.map((word, index) => {
                  return <Word key={index} {...word} />
                })}
              </div>
            ))}
          </div>
        </div>
      )}
      {slideData.layout === 'random' && (
        <div className={classes.randomBank}>
          <div className={classes.randomBankHolder}>
            {shuffledWords.map((word, index) => (
              <Word key={index} {...word} random />
            ))}
          </div>
        </div>
      )}
      <ScrollFade />
    </Slide>
  )
})

export default withPresentation(injectSheet(styles)(WordBankSlide))
